import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';

import { AumicoCoreProvider } from '../../../../aumico-lib-core-fe/src/lib';
import { UsersConfig, UsersConfigService } from '../../../../aumico-lib-users-fe/src/lib/users.config';
import { RoutesUtil } from '../../../../aumico-lib-users-fe/src/lib/util/RoutesUtil';
import { CreateWorkflowDto } from '../dtos/create-workflow-dto.interface';
import { UpdateWorkflowDto } from '../dtos/update-workflow-dto.interface';
import { WorkflowDto } from '../dtos/workflow-dto.interface';
import { WorkflowsFilter } from '../interfaces/workflows-filter.interface';

@Injectable({
    providedIn: 'root',
})
export class WorkflowsService {
    constructor(
        private http: HttpClient,
        @Inject(UsersConfigService) config: UsersConfig,
        private readonly coreProvider: AumicoCoreProvider,
        private routesUtil: RoutesUtil,
    ) {}

    getWorkflows(filter?: WorkflowsFilter): Observable<WorkflowDto[]> {
        this.coreProvider.dispatchBlockingRequest('[Aumico-Workflows] Get Workflows');

        const params = this.routesUtil.buildHttpParams(filter);

        const url = this.routesUtil.getWorkflows();

        return this.http
            .get<WorkflowDto[]>(url, { params })
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('[Aumico-Workflows] Get Workflows')));
    }

    getWorkflowById(workflowId: string): Observable<WorkflowDto> {
        this.coreProvider.dispatchBlockingRequest('[Aumico-Workflows] Get Workflow By Id');

        const url = this.routesUtil.getWorkflowById(workflowId);

        return this.http
            .get<WorkflowDto>(url)
            .pipe(
                finalize(() => this.coreProvider.dispatchBlockingRequestEnd('[Aumico-Workflows] Get Workflow By Id')),
            );
    }

    createWorkflow(createWorkflowDto: CreateWorkflowDto): Observable<WorkflowDto> {
        this.coreProvider.dispatchBlockingRequest('[Aumico-Workflows] Create Workflow');

        const url = this.routesUtil.getWorkflows();

        return this.http
            .post<WorkflowDto>(url, createWorkflowDto)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('[Aumico-Workflows] Create Workflow')));
    }

    updateWorkflow(workflowId: string, updateWorkflowDto: UpdateWorkflowDto): Observable<WorkflowDto> {
        this.coreProvider.dispatchBlockingRequest('[Aumico-Workflows] Update Workflow');

        const url = this.routesUtil.getWorkflowById(workflowId);

        return this.http
            .put<WorkflowDto>(url, updateWorkflowDto)
            .pipe(finalize(() => this.coreProvider.dispatchBlockingRequestEnd('[Aumico-Workflows] Update Workflow')));
    }

    deleteWorkflow(workflowId: string): Observable<void> {
        this.coreProvider.dispatchBlockingRequest('[Aumico-Workflows] Delete Workflow By Id');

        const url = this.routesUtil.getWorkflowById(workflowId);

        return this.http
            .delete<void>(url)
            .pipe(
                finalize(() =>
                    this.coreProvider.dispatchBlockingRequestEnd('[Aumico-Workflows] Delete Workflow By Id'),
                ),
            );
    }
}
